import z from 'zod';

const envSchema = z.object({
  // app
  VITE_APP_VERSION: z.string().default('development'),
  VITE_ENVIRONMENT_NAME: z.string().default('development'),
  MODE: z.string().default('development'),
  // keycloak
  VITE_KEYCLOAK_API_URL: z.string(),
  VITE_KEYCLOAK_CLIENT_ID: z.string(),
  VITE_KEYCLOAK_REALM: z.string(),

  // PERSON API
  VITE_PERSON_API_URL: z.string(),
});

const env = envSchema.parse(import.meta.env);

export default env;

declare global {
  export interface ImportMetaEnv extends z.infer<typeof envSchema> {}
}
